import React from 'react';
import {MasterLayout} from 'layout';
import { Danhmuc } from 'api';
import htmlToDraft from 'html-to-draftjs';
import { EditorState, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';

class Help extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      label: '',
      content: ''
    };
  }

  componentDidMount() {
    this.getListData();
  }
  getListData() {
    Danhmuc.actions.getHuongDanSuDung.request().then(res => {
      if (res.data && res.data._embedded && res.data._embedded.huongDanSuDungs) {
        const contentBlock = htmlToDraft(res.data._embedded.huongDanSuDungs[0].noiDung);
        const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
        const editorState = EditorState.createWithContent(contentState);
        this.setState({
          label: res.data._embedded.huongDanSuDungs[0].ten,
          content: editorState
        });
      }
    });
  }
  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <div className="center reception-container">
          <div className="top-content">
            <div className="left-content">
              <p className="title-18"><i className="tt tt-reception"></i>{this.state.label}</p>
            </div>
          </div>
          <div className="bottom-content">
            <section className="page-wrapper" style={{padding: '0px 20px'}}>
              <Editor
                readOnly={true}
                editorState={this.state.content}
                wrapperClassName="wrapper-editor mb18"
                editorClassName="container-editor"
                editorStyle={{
                    minHeight: 350,
                    border: "none",
                    height: "auto"
                }}
                toolbarHidden={true}
              />
            </section>
          </div>
        </div>
      </MasterLayout>
    );
  }
}

export default Help;


// WEBPACK FOOTER //
// ./src/components/modules/home/Help.jsx